import cn from 'classnames';

import Icon from '@publicImages/svg/share.svg?icon';

type SocialShareType = { ariaLabel?: string; className?: string };

const SocialShare = ({ className }: SocialShareType) => <Icon className={cn('SocialShare', className)} />;

export default SocialShare;
